import { useQuery } from "react-query";
import { Card, Select } from "antd";
import { useTranslation } from "react-i18next";
import { mdlSpoReportRoomTypeListRequest } from "../../models/service-models/action/SpoReportRoomTypeListRequest";
import { ActionService } from "../../services/ActionService";
import { useEffect } from "react";

export type SpoRoomTypeSelectProps = {
    hotelIds?: string[];
    onChange?: Function;
    value?: any;
    mode?: "multiple" | "tags" | undefined;
    defaultAllSelected?: boolean;
    formSetter?: Function;
}


export const SpoRoomTypeSelect = (props: SpoRoomTypeSelectProps) => {
    const { t } = useTranslation();

    const {
        data,
        isLoading,
        isError,
        refetch
    } = useQuery(
        ["getRoomTypes", props.hotelIds],
        () => {
            if (props.hotelIds) {
                var request: mdlSpoReportRoomTypeListRequest = { hotelIds: props.hotelIds };
                return ActionService.ReportRoomTypeList(request);
            }

        },
        {
            onSuccess(data) {
                if (props.defaultAllSelected) {
                    props.formSetter!("roomType", data?.body?.data?.map((roomType) => roomType.id!));
                }
            },
            refetchOnWindowFocus: false,
            enabled: !!props.hotelIds
        }
    );

    const onFocus = () => {
        let i;
        const el = document.getElementsByClassName(
            "ant-select-selection-search-input"
        );
        for (i = 0; i < el.length; i++) {
            el[i].setAttribute(
                "autocomplete",
                "registration-select"
            );
        }
    }

    useEffect(() => {

    }, [data])


    return (
        <Select
            loading={isLoading}
            mode={props.mode}
            size="middle"
            maxTagCount={3}
            onFocus={onFocus}
            value={props.mode == "multiple" ? props.value ? props.value as string[] : props.defaultAllSelected ? data?.body?.data?.map((roomType) => roomType.id!) : undefined : props.value as string}
            onChange={(value: string | string[]) => props.onChange ? props.onChange(value) : undefined}
            showSearch
            placeholder={t("common.chooseRoomType")}
            filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            options={data?.body?.data?.map(h => Object.assign(h, {
                label: h.name,
                value: h.id
            }))}
        />
    )
}